<template>
  <div class="Setdepartment CommonContentSingle-gray">
    <el-container>
      <el-header class="Setdepartment_top" style="background: rgba(255, 255, 255, 1); height: auto;">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="multipleTable" style="
              margin: 0px 0px;
              background: rgba(255, 255, 255, 1);
              padding: 10px;
              overflow: hidden;
              height: 42px;
            ">
          <el-form-item style="" label="部门编号">
            <el-input v-model="formInline.DeptID" placeholder="部门编号"></el-input>
          </el-form-item>
          <el-form-item label="部门名称">
            <el-input v-model="formInline.DeptName" placeholder="部门名称"></el-input>
          </el-form-item>


          <el-form-item style="" label="教学编码">
            <el-input v-model="formInline.TestID" placeholder="教学编码"></el-input>
          </el-form-item>


          <el-form-item style="" label="教学名称">
            <el-input v-model="formInline.TestName" placeholder="教学名称"></el-input>
          </el-form-item>



          <el-form-item class="cvbb" style="width: 260px;">
            <el-button id="focus" @click="screening" @keyup.enter.capture="enterSearch" type="primary">
              筛选
            </el-button>
            <el-button @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>

      <el-main class="Thelist">
        <div>
          <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
            添加部门
          </el-button>
          <el-button type="primary" @click="dialogVisible = true" plain>
            批量导入
          </el-button>
        </div>
        <div class="Thelist_left">
          <h2>部门名称</h2>
          <el-tree :data="data" node-key="value" check-strictly :expand-on-click-node="false" @node-click="nodeExpand"
            @node-expand="nodeExpand" ref="treeForm"></el-tree>
        </div>

        <div class="Thelist_right">
          <h2>子部门名称</h2>
          <el-table :data="tableData" style="width: 100%;" @sort-change="sorting">
            <el-table-column label="序号" width="60px" align="left">
              <template slot-scope="scope" center>
                {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="部门编号">
              <template slot-scope="scope">
                <span style="margin-left: 10px;">{{ scope.row.DeptID }}</span>
              </template>
            </el-table-column>
            <el-table-column label="部门名称">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>部门名称: {{ scope.row.DeptName }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span size="medium">{{ scope.row.DeptName }}</span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column label="联系人">
              <template slot-scope="scope">
                <span style="margin-left: 10px;">
                  {{ scope.row.ContactName }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="联系方式" min-width="130">
              <template slot-scope="scope">
                <span style="margin-left: 10px;">
                  {{ scope.row.ContactPhone }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="CreatedDate" label="创建时间" min-width="170px" sortable="custom">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>创建时间: {{ scope.row.CreatedDate }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span size="medium">{{ scope.row.CreatedDate }}</span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="排序" width="80" prop="LineNumber" sortable="custom">
              <template slot-scope="scope">
                <span style="margin-left: 10px;">
                  {{ scope.row.LineNumber }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
                  编辑
                </el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleCurrentChange"
              :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts"
              :hide-on-single-page="wpppd"></el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- =============新增================ -->
    <el-drawer class="cldrawer" title="我是标题" :visible.sync="drawer" :with-header="false" v-loading="drawer_loadings">
      <h2>创建部门</h2>
      <el-form class="el_form" :rules="wrules" ref="form" :model="form" label-width="80px">


        <el-form-item label="上级部门" prop="bumen">
          <div class="block">
            <el-cascader class="last-dept" ref="wcascader" @change="Selected_to_shut_down" @expand-change="bumen"
              :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
          </div>
        </el-form-item>

        <el-form-item label="教学部门" prop="bumen">
            <div class="block">
              <el-cascader class="last-dept" ref="teaching" @change="teaching_click" @expand-change="bumen"
                :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
            </div>
          </el-form-item>

        <el-form-item label="部门编号" prop="DeptID">
          <el-input placeholder="部门编号" maxlength="25" v-model="form.DeptID"></el-input>
        </el-form-item>

        <el-form-item label="部门名称" prop="DeptName">
          <el-input placeholder="部门名称" maxlength="25" v-model="form.DeptName"></el-input>
        </el-form-item>

        <el-form-item label="部门类型" prop="DeptName">
          <el-select v-model="form.DeptType" placeholder="请选择部门类型">
            <el-option v-for="item in DeptTypeoptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input placeholder="联系人" maxlength="20" v-model="form.ContactName"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input placeholder="联系方式" v-model="form.ContactPhone"></el-input>
        </el-form-item>
        <el-form-item placeholder="排序" label="排序">
          <el-input-number v-model="form.LineNumber" controls-position="right" :min="1" :max="10000000">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div class="cldrawer_btn">
        <el-button type="success" @click="onSubmit">保存</el-button>
        <el-button type="warning" @click="drawer = false">取消</el-button>
      </div>
    </el-drawer>
    <!-- =============新增================ -->

    <!-- =============修改================ -->
    <el-drawer class="cldrawer" title="我是标题" :visible.sync="drawer2" :with-header="false">
      <h2>部门修改</h2>

      <el-form class="el_form" :rules="rules" ref="form" prop="RoleID" :model="xform" label-width="80px">

        <el-form-item label="上级部门" prop="option">
          <el-cascader :placeholder="pdid ? '' : '请选择'" class="last-dept" empty ref="wcascaders" @expand-change="bumens"
            @change="Selected_to_shut_down2" v-model="option" :options="options" :props="{ checkStrictly: true }"
            clearable></el-cascader>
        </el-form-item>

        <el-form-item label="教学部门" prop="teaching_modify">
          <el-cascader :placeholder="pdid ? '' : '请选择'" class="last-dept" empty ref="teaching_modify" @expand-change="bumens"
            @change="teaching_modify_click" v-model="Reverse_data" :options="options" :props="{ checkStrictly: true }"
            clearable></el-cascader>
        </el-form-item>

        <el-form-item label="部门编号" prop="DeptID">
          <el-input disabled="disabled" placeholder="部门编号" maxlength="25" v-model="xform.DeptID"></el-input>
        </el-form-item>

        <el-form-item label="部门名称" prop="DeptName">
          <el-input placeholder="部门名称" maxlength="25" v-model="xform.DeptName"></el-input>
        </el-form-item>

        <el-form-item label="部门类型" prop="DeptName">
          <el-select v-model="xform.DeptType" placeholder="请选择部门类型">
            <el-option v-for="item in DeptTypeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系人">
          <el-input placeholder="联系人" maxlength="25" v-model="xform.ContactName"></el-input>
        </el-form-item>

        <el-form-item label="联系方式">
          <el-input placeholder="联系方式" v-model="xform.ContactPhone"></el-input>
        </el-form-item>

        <el-form-item placeholder="排序" label="排序">
          <el-input-number v-model="xform.LineNumber" controls-position="right" :min="1" :max="10000000"></el-input-number>
        </el-form-item>

      </el-form>

      <div class="cldrawer_btn">
        <el-button type="primary" @click="Modify">立即修改</el-button>
        <el-button @click="drawer2 = false">取消</el-button>
      </div>
    </el-drawer>
    <!-- =============修改================ -->
    <el-dialog v-loading="loadingsss" element-loading-text="上传中..." element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)" title="批量导入" :visible.sync="dialogVisible" width="30%;"
      :before-close="handleClose">

      <div class="down_template" @click="down_template">
        <i class="el-icon-download"></i>
        <span>下载模板</span>
      </div>

      <div class="up_template">
        <el-upload drag ref="upload" :limit="limitNum" :auto-upload="false" accept=".xls,.xlsx" :action="UploadUrl()"
          :on-remove="handleRemove" :before-upload="beforeUploadFile" :on-change="fileChange" :on-success="handleSuccess"
          :on-error="handleError" :file-list="fileList" :on-exceed="exceedFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx,xls文件，且不超过10M
          </div>
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="uploadFile">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="gdds" title="当前报错信息" :visible.sync="dialogVisible2" width="30%;" :before-close="handleClose">
      <el-table :data="tableDatassss" style="width: 100%;">
        <el-table-column class="sfsfs" prop="Line" label="行数" mi-width="30%"></el-table-column>
        <el-table-column prop="Message" label="错误信息" mi-width="70%"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      DeptTypeoptions: [
        {
          value: '1',
          label: '学校',
        },
        {
          value: '2',
          label: '学院',
        },
        {
          value: '3',
          label: '专业',
        },
        {
          value: '4',
          label: '班级',
        },
      ],
      wpppd: true,
      pdid: true,
      pageIndexs: 1,
      sortingss: '',
      Student_id: '',
      create_time: '',
      Counts: 0, //分页总条数
      loadingsss: false,
      drawer_loadings: false,
      currentPage1: 1,
      dialogVisible: false,
      dialogVisible2: false,
      types: '1', //查询类型1是搜索2是下拉框
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [],
      DeptIDs: '',
      DeptNames: '',
      tableDatassss: '',
      form: {
        PDeptID: '',
        DeptID: '',
        DeptName: '',
        DeptAddress: '',
        ContactName: '',
        ContactPhone: '',
        DeptRecommand: '',
        DeptPicture: '',
        LineNumber: '',
        DeptType: '1',
        TestID:'',
      },
      xform: {
        PDeptID: '',
        DeptID: '',
        DeptName: '',
        DeptType: '1',
        DeptAddress: '',
        ContactName: '',
        ContactPhone: '',
        DeptRecommand: '',
        DeptPicture: '',
        LineNumber: '',
        PDeptName: '',
        TestID: '',
      },
      options: [],
      option: [],
      Reverse_data: ["DeptID01", "123456"],

      data: [],
      tableData: [], //表格数组
      activeName: 'second',
      drawer: false,
      drawer2: false,
      formInline: {
        DeptID: '',
        DeptName: '',
        TestID: '',
        TestName: '',
      },
      arr: [],
      rules: {
        option: [{ required: true, message: '请选择上级部门', trigger: 'blur'},],
        DeptID: [{required: true, message: '请输入部门编号', trigger: 'blur'},],
        DeptName: [{required: true, message: '请输入部门名称', trigger: 'blur'},],
        teaching_modify: [{required: true, message: '请选择教学部门', trigger: 'blur'},],
      },
      wrules: {
        bumen: [{ required: true, message: '请选择上级部门', trigger: 'blur' }],
        DeptID: [{ required: true, message: '请输入部门编号', trigger: 'blur' },],
        DeptName: [{ required: true, message: '请输入部门名称', trigger: 'blur' },],
        teaching: [{ required: true, message: '请选择教学部门', trigger: 'blur' },],
      },
    };
  },
  components: {},
  methods: {
    sorting({ column, prop, order }) {
      if (prop == 'CreatedDate') {
        this.create_time = order;
        this.sortingss = '';
      } else if (prop == 'LineNumber') {
        this.sortingss = order;
        this.create_time = '';
      }
      if (this.types == 1) {
        this.loading(this.formInline.DeptID,this.formInline.DeptName,this.currentPage1,this.sortingss,this.create_time, this.formInline.TestID, this.formInline.TestName);
      } else if (this.types == 2) {
        this.loading(this.DeptIDs,this.DeptNames,this.currentPage1,this.sortingss,this.create_time, this.formInline.TestID, this.formInline.TestName);
      }
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.closeAll();
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
    },
    enterSearch(ea) { },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList.push(file.raw);
    },
    handleRemove() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      //this.fileList=file;
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx' || extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx,xls的文件');
      }
      if (size > 1) {
        this.$message.warning('文件大小不得超过1M');
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success('文件上传成功');
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return '';
    },
    extraData() {
      return {
        name: this.form.name,
        version: this.form.version,
        type: this.form.type,
      };
    },
    uploadFile() {
      //  @click="dialogVisible = false"
      if (this.fileList.length === 0) {
        this.$message.warning('请上传文件');
      } else {
        this.loadingsss = true;
        let config = {headers: {'Content-Type': 'multipart/form-data',}};
        var fd = new FormData();
        fd.append('file', this.fileList[0]);
        this.$Http_Post('ReportCriData/UploadDeptInfoFile', fd).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingsss = false;
            this.$refs.upload.clearFiles();
            this.fileList = [];
            this.Global.request_successful(res.Message);
            this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',content: '',}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('department', JSON.stringify(res.Data));
                this.data = res.Data;
              }
            });
          } else {
            this.loadingsss = false;
            this.Global.request_failure(res.Message);
            this.dialogVisible2 = true;
            this.tableDatassss = res.Data;
            this.$refs.upload.clearFiles();
            this.fileList = [];
          }
        });
      }
    },
    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i];
          break;
        } else if (
          this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
          DeptID: dt[dt.length - 1],
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
      // this.$refs.wcascader.dropDownVisible = false
    },

    teaching_modify_click(dt) {
      this.xform.TestID = dt[dt.length - 1];
      this.$refs.teaching_modify.dropDownVisible = false;
    },

    teaching_click(dt) {
      this.form.TestID = dt[dt.length - 1];
      this.$refs.teaching.dropDownVisible = false;
    },

    Selected_to_shut_down(dt) {
      this.form.PDeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    Selected_to_shut_down2(dt) {
      this.pdid = false;
      this.xform.PDeptID = dt[dt.length - 1];
      this.$refs.wcascaders.dropDownVisible = false;
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi &&
          NodeList[i].children.length > 0 &&
          NodeList[i].children[0].DeptID != '-1'
        ) {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },

    bumens(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i];
          break;
        } else if (
          this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(dt[dt.length - 1],this.options[i].children);
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
          DeptID: dt[dt.length - 1],
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
      // this.$refs.wcascaders.dropDownVisible = false
    },

    nodeExpand(dt, obj, node) {
      if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
        dt.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: dt.DeptID,content: '',}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data;
            }
          }
        });
      }

      this.arr = dt.DeptID;
      this.currentPage1 = 1;
      this.types = '2';
      this.loading(dt.DeptID,dt.DeptName,'1',this.sortingss,this.create_time, this.formInline.TestID, this.formInline.TestName);
      this.DeptIDs = dt.DeptID;
      this.DeptNames = dt.DeptName;
    },
    handleCurrentChange(val) {
      if (this.types == 1) {
        this.loading(
          this.formInline.DeptID,
          this.formInline.DeptName,
          val,
          this.sortingss,
          this.create_time,
          this.formInline.TestID, this.formInline.TestName
        );
      } else if (this.types == 2) {
        this.loading(
          this.DeptIDs,
          this.DeptNames,
          val,
          this.sortingss,
          this.create_time,
          this.formInline.TestID, this.formInline.TestName
        );
      }
    },
    handleEdit(index, row) {
      //修改反写
      this.pdid = true;
      this.drawer2 = true;
      this.$Http_Post('DepartMent/UpdateDeptMentInfo', {
        DeptID: row.DeptID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.option = res.Data.deptids.reverse();
          this.Reverse_data = res.Data.TestidList.reverse();
          this.xform.PDeptID = res.Data.PDeptID; //父部门id
          this.xform.DeptID = res.Data.DeptID;
          this.xform.DeptAddress = res.Data.DeptAddress;
          this.xform.ContactName = res.Data.ContactName;
          this.xform.ContactPhone = res.Data.ContactPhone;
          this.xform.DeptRecommand = res.Data.DeptRecommand;
          this.xform.LineNumber = res.Data.LineNumber;
          this.xform.DeptName = res.Data.DeptName;
          this.xform.PDeptName = res.Data.PDeptName;
          this.xform.DeptType = res.Data.DeptType.toString();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    vecve() {
      this.$router.push('/consulting/AppointmentList');
    },
    Modify() {
      //修改按钮

      // if (!this.xform.PDeptID) {
      //   this.$message.error("请选择上级部门！");
      //   return false
      // }

      // if (!this.xform.TestID) {
      //   this.$message.error("请选择教学部门！");
      //   return false
      // }

      // if (!this.xform.DeptID) {
      //   this.$message.error("请输入部门编号！");
      //   return false
      // }
      // if (!this.xform.DeptName) {
      //   this.$message.error("请输入部门名称！");
      //   return false
      // }



      this.$Http_Post('DepartMent/UpdateDeptMent', this.xform).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$Http_Post('DepartMent/GetDeprtMentByNode', {
            DeptID: '',
            content: '',
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.data = res.Data;
            }
          });

          this.drawer2 = false;
          if (this.types == 1) {
            this.loading(
              this.formInline.DeptID,
              this.formInline.DeptName,
              this.currentPage1,
              this.sortingss,
              this.create_time,
              this.formInline.TestID, this.formInline.TestName
            );
          } else if (this.types == 2) {
            this.loading(
              this.DeptIDs,
              this.DeptNames,
              this.currentPage1,
              this.sortingss,
              this.create_time,
              this.formInline.TestID, this.formInline.TestName
            );
          }
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    handleDelete(index, row) {
      //删除
      this.$confirm('数据删除后无法恢复, 是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
      })
        .then(() => {
          this.$Http_Post('DepartMent/DeleteDeptMent', {
            DeptID: row.DeptID,
          })
            .then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('department', '');
                this.Global.request_successful(res.Message);
                this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
                  DeptID: '',
                  content: '',
                }).then((res) => {
                  if (res.Code == 200 || res.Code == 0) {
                    this.data = res.Data;
                  }
                });

                if (this.types == 1) {
                  this.loading(
                    this.formInline.DeptID,
                    this.formInline.DeptName,
                    this.currentPage1,
                    this.sortingss,
                    this.create_time,
                    this.formInline.TestID, this.formInline.TestName
                  );
                } else if (this.types == 2) {
                  this.loading(
                    this.DeptIDs,
                    this.DeptNames,
                    this.currentPage1,
                    this.sortingss,
                    this.create_time,
                    this.formInline.TestID, this.formInline.TestName
                  );
                }

                this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
                  DeptID: '',
                  content: '',
                }).then((res) => {
                  if (res.Code == 200 || res.Code == 0) {
                    this.data = res.Data;
                  }
                });
              } else {
                this.Global.request_failure(res.Message);
              }
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: err.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    down_template() {
      window.location.replace(
        
        // this.Global.ApiUrl + 'File/TemplateFile/数据上报_部门导入.xls'
        process.env.VUE_APP_URL + 'File/TemplateFile/数据上报_部门导入.xls'
      );
    },
    onSubmit() {
      //创建

      if (!this.form.PDeptID) {
        this.$message.error("请选择上级部门！");
        return false
      }

      if (!this.form.TestID) {
        this.$message.error("请选择教学部门！");
        return false
      }

       if (!this.form.DeptID) {
        this.$message.error("请输入部门编号！");
        return false
      }
      if (!this.form.DeptName) {
        this.$message.error("请输入部门名称！");
        return false
      }

      this.drawer_loadings = true;
      this.$Http_Post('DepartMent/AddDeptMent', this.form).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.drawer = false;
          this.Global.request_successful(res.Message);
          this.drawer_loadings = false;
          this.loading('', '', '1', this.sortingss, this.create_time, this.formInline.TestID, this.formInline.TestName);

          this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
            DeptID: '',
            content: '',
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.options = res.Data;
              this.data = res.Data;
            }
          });
        } else {
          this.drawer_loadings = false;
          this.Global.request_failure(res.Message);
        }
      });
    },
    resetForm(formInline) {
      this.formInline.DeptID = '';
      this.formInline.DeptName = '';
      this.loading('', '', '1', this.sortingss, this.create_time, this.formInline.TestID, this.formInline.TestName);
    }, //重置
    screening() {
      //筛选this.types = '1';
      this.types = '1';
      this.currentPage1 = 1;
      this.loading(
        this.formInline.DeptID,
        this.formInline.DeptName,
        this.currentPage1,
        this.sortingss,
        this.create_time,
        this.formInline.TestID, this.formInline.TestName
      );
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    loading(val, type, numder, sortingss, create_time, TestID, TestName) {
      //this.GetDeprtMentByNode(val,"")
      this.pageIndexs = numder; //表格数据获取接口
      var from = {
        DeptID: val,
        DeptName: type,
        TestID: TestID,
        TestName: TestName,
      };

      this.$Http_Post('DepartMent/GetSubDeptList', {
        from,
        pageSize: '10',
        pageIndex: numder,
        type: this.types,
        sort: sortingss,
        datasort: create_time,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data.Lists;
          this.Counts = Number(res.Counts);
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }

          var wlists = [];
          for (var i = 0; i < res.Data.Lists.length; i++) {
            wlists.push(res.Data.Lists[i].DeptID);
          }
        } else {
          // this.Global.request_successful(res.Message);
          if (Number(from.pageIndex) > 1) {
            from.pageIndex = from.pageIndex - 1;
            this.currentPage1 = this.currentPage1 - 1;
            this.loading(
              this.form,
              this.seledeptid,
              this.currentPage1,
              this.sortingss,
              this.create_time,
              this.formInline.TestID, this.formInline.TestName
            );
          } else {
            this.tableData = res.Data.Lists;
            this.totalnumber = Number(res.Counts);
          }
        }
      });
    },

    GetDeprtMentByNode(DeptID, content) {
      this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
        DeptID: '',
        content: content,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.options = res.Data;
          if (res.Data) {
            this.data = res.Data;
          }
        } else {
        }
      });
    },
  },
  mounted() {
    this.loading('', '', '1', this.sortingss, this.create_time, this.formInline.TestID, this.formInline.TestName);
    let deptInfo = sessionStorage.getItem('department');
    this.options = deptInfo != '' ? JSON.parse(sessionStorage.getItem('department')) : '';
    this.GetDeprtMentByNode('', '');
  },
  created() {
    this.enterSearch();
    // this.options = JSON.parse(sessionStorage.getItem('department'));
    // this.data = JSON.parse(sessionStorage.getItem('department'));
  },
};
</script>
<style>
.Setdepartment .Setdepartment_top {
  font-size: 20px;
  border: 1px solid #e3e3e3;
  margin-top: -1px;
  background-color: #fff;
  margin-left: 0px;
}

.Setdepartment button {
  height: 38px;
}

.Setdepartment .Thelist {
  background-color: #fff;
  margin-top: 15px;
}

.Setdepartment .Thelist button {
  height: 36px;
  line-height: 10px;
}

.Setdepartment .Thelist_left {
  width: 300px !important;
  border: 1px solid rgba(225, 226, 227, 1);
  margin-top: 15px;
  float: left;
  height: calc(100% - 52px) !important;
  overflow-y: auto;
}

.Setdepartment .Thelist_right {
  width: calc(100% - 315px) !important;
  border: 1px solid rgba(225, 226, 227, 1);
  float: right;
  margin-top: 15px;
  height: calc(100% - 52px) !important;
  overflow-y: auto;
}

.Setdepartment .Thelist_left h2 {
  padding: 18px;
  font-size: 18px;
}

.Setdepartment .Thelist_right h2 {
  padding: 18px;
  font-size: 18px;
}

.cldrawer {
  height: calc(100% - 40px);
}

.Setdepartment .cldrawer h2 {
  padding: 18px;
  font-size: 18px;
}

.Setdepartment .el_form {
  width: 70%;
  margin-left: 20px;
}

.Setdepartment .cldrawer_btn {
  margin-left: 30%;
  margin-top: 40px;
  margin-bottom: 20px;
}

.Setdepartment .el-dialog {
  width: 41%;
  height: 400px;
}

.Setdepartment .down_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  margin-left: 32%;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.Setdepartment .up_template {
  width: 220px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e3e3e3;
  margin-left: 32%;
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}

.Setdepartment .el-dialog__footer {
  text-align: center;
  margin-top: 90px !important;
}

.Setdepartment .el-upload-dragger .el-upload__text {
  color: #606266;
  font-size: 14px;
  text-align: center;
  margin-top: -20px;
}

.Setdepartment .el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 9px 0 16px;
  line-height: 50px;
}

.Setdepartment .el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 220px;
  height: 118px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.Setdepartment .el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: -32px;
  width: 220px;
}

.Setdepartment .el-upload-list__item:first-child {
  margin-top: -19px;
}

.Setdepartment .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.Setdepartment .el-dialog {
  width: 41%;
  height: 400px;
}

.Setdepartment .gdds .el-dialog {
  overflow-y: scroll;
}

.Setdepartment .el-table .cell {
  text-align: center;
}

.Setdepartment .el-textarea .el-input__count {
  height: 20px;
  bottom: 12px;
}

.last-dept,
.address-class {
  width: 100%;
}
</style>
